import { Injectable } from '@angular/core';
import { GsonCoreService } from './core/gson.core.service'

@Injectable()
export class ProductService {

  constructor(private gson:GsonCoreService) { }

  readRandomIds(): Promise<any> {
    return this.gson.singleRead("rand-pid");
  }

  readTypes(): Promise<any> {
    return this.gson.singleRead("type");
  }

  readColors(): Promise<any> {
    return this.gson.singleRead("color");
  }

  readSizes(): Promise<any> {
    return this.gson.singleRead("size");
  }

  readById(id:number): Promise<any> {
    return this.gson.read("pid", [{ "name": "id", "value": id }]);
  }

  readImagesByProductId(id:number): Promise<any> {
    return this.gson.read("pimg", [{ "name": "id", "value": id }]);
  }

  readProductsByPage(productIds:number){
    return this.gson.read("pbyid",[{"name":"pids","value":""+productIds}]);
  }

  readInventory(): Promise<any> {
    return this.gson.singleRead("inv-p");
  }

}



// WEBPACK FOOTER //
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/services/product.service.ts